module.exports = __webpack_public_path__ + "static/media/parking.8996746f.svg";